import type { SurveyTokenData } from './surveys'
import { resolvePlaceholders } from './placeholders'

const PREVIEW_VALUES = {
    'client-name': 'Maria Santos',
    'company-name': 'Appointmint',
    date: '15-03-2025',
    time: '10:30',
    'professional-name': 'Dra. Ana Silva',
    'appointment-type': 'Consulta Geral',
    'survey-link': import.meta.env.VITE_FORMS_BASE_URL,
} as const

export const resolveSurveyDescription = (
    tokenData: SurveyTokenData,
    fallbackText: string,
    isPreview: boolean,
    surveyLink?: string,
): string => {
    const template = tokenData.survey.description ?? fallbackText

    const resolved = resolvePlaceholders(template, {
        clientName: isPreview ? PREVIEW_VALUES['client-name'] : tokenData.clientName,
        companyName: tokenData.companyName || (isPreview ? PREVIEW_VALUES['company-name'] : ''),
        date: isPreview ? PREVIEW_VALUES.date : tokenData.appointmentDate,
        time: isPreview ? PREVIEW_VALUES.time : tokenData.appointmentTime,
        professionalName: isPreview ? PREVIEW_VALUES['professional-name'] : tokenData.professionalName,
        appointmentType: isPreview ? PREVIEW_VALUES['appointment-type'] : tokenData.appointmentType,
        surveyLink: surveyLink || (isPreview ? PREVIEW_VALUES['survey-link'] : ''),
    })

    if (!isPreview) {
        return resolved
    }

    return resolved.replace(/\{[^}]+\}/g, '...')
}
